module.exports = __webpack_public_path__ + "static/img/check.5ac71f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/check.png
// module id = 1651
// module chunks = 0